<template>
  <v-tooltip
    top
    :color="schema.tooltipColorClass"
    :disabled="!schema.tooltip && !schema.tooltipDisabled"
    :key="generateId(schema.model)"
  >
    <template v-slot:activator="{ on, attrs }">
      <div
        :class="[{ 'd-flex': schema.attributesInfo }, getSelectedDEV && 'dev-selected-component']"
        @contextmenu="selectComponentDEV($event, schema.model)"
        v-on="on"
        v-bind="attrs"
        :data-has-tooltip="schema.attributes.disabled ? schema.tooltipDisabled : schema.tooltip ? 'true' : 'false'"
        :data-tooltip="schema.attributes.disabled ? schema.tooltipDisabled : schema.tooltip"
      >
        <i4pro-icon-popover
          v-if="schema.attributesInfo"
          :class="[schema.attributesInfo.right ? 'ml-1 order-2' : 'mr-1']"
          :schema="schema"
          :model="model"
        ></i4pro-icon-popover>

        <v-checkbox
          :rules="rules"
          :value="schema.value"
          :name="schema.model"
          :id="generateId(schema.model)"
          v-model="value"
          v-bind="schema.attributes"
          :disabled="schema.readonly"
          @blur="onBlur"
          @change="onChange"
          @focus="onFocus"
          @input="onInput"
        >
          <template v-slot:label>
            <span v-bind="schema.attributes.attributesLabel">
              {{ labelText }}
            </span>
            <span v-if="schema.rules.includes('required')" class="red--text">*</span>
          </template>
        </v-checkbox>
      </div>
    </template>
    <span>{{ schema.attributes.disabled ? schema.tooltipDisabled : schema.tooltip }}</span>
  </v-tooltip>
</template>

<script>
import { abstractField } from 'vue-form-generator';
import devComponentMixin from '@/mixins/dev-component-mixin';
import rulesMixin from '@/mixins/rules-mixin';
import inputEventsMixin from '@/mixins/input-events-mixin';
import * as HANDLERS from '@/helpers/types/handlers';
import componentMixin from '@/mixins/component-mixin';

export default {
  mixins: [abstractField, devComponentMixin, rulesMixin, inputEventsMixin, componentMixin],

  components: {
    i4proIconPopover: () => import('@/components/icons/i4pro-icon-popover')
  },

  data() {
    return {
      required: v => (v === undefined || v === null ? `Este campo é obrigatório` : true)
    };
  },

  computed: {
    labelText() {
      return this.model[`${this.schema.model}_label`] ?? this.schema.attributes.label;
    }
  },

  events: {
    [HANDLERS.ENABLED_FIELD]: 'active'
  },

  methods: {
    active: function (field) {
      if (this.schema.model == field) this.schema.readonly = false;
    },

    onChange: async function () {
      this.changeEvents();
    }
  }
};
</script>
